// Local translations
export const T = {
  en_GB: {
    advisorCannotAccess:
      "Advisors cannot access public client links. Please sign out from the advisor dashboard first.",
    invalidOrExpiredLink: "Invalid or expired signature link",
    failedToLoadSignaturePage: "Failed to load signature page",
    unableToLoadSignaturePage: "Unable to Load Signature Page",
    contactAdvisorForAssistance: "Please contact your advisor for assistance.",
    documentSigning: "Document Signing",
    welcome: "Welcome,",
    requestedToSign: "You have been requested to sign documents using your digital ID",
    secureDigitalSigning: "Secure Digital Signing",
    secureDigitalSigningDesc:
      "You will be redirected to a secure signing portal where you can use your electronic ID (MitID, BankID, or similar) to sign the documents.",
    whatHappensNext: "What happens next?",
    step1: "Click the button below to start the signing process",
    step2: "You will be redirected to the secure Criipto signing portal",
    step3: "Choose your preferred electronic ID method",
    step4: "Authenticate using your chosen eID",
    step5: "Review and sign the documents",
    step6: "You will receive a confirmation when signing is complete",
    currentStatus: "Current Status:",
    signed: "Signed",
    inProgress: "In Progress",
    pending: "Pending",
    expired: "Expired",
    cancelled: "Cancelled",
    failed: "Failed",
    signedLabel: "Signed:",
    signerLabel: "Signer:",
    signatureSuccessfullyCompleted: "Your signature has been successfully completed!",
    alreadySigned: "Already Signed",
    startSigningProcess: "Start Signing Process",
    checkStatus: "Check Status",
    secureAndCompliant: "Secure & Compliant",
    secureAndCompliantDesc:
      "This signing process uses Criipto Signatures, a trusted digital signature provider. Your documents will be signed according to PAdES-LTA standards, ensuring legal validity.",
    afterSigning: "After Signing",
    afterSigningDesc:
      'After completing the signing process on the Criipto portal, return to this page and click "Check Status" to verify your signature was received.',
    needHelp: "Need Help?",
    needHelpDesc:
      "If you experience any issues with the signing process, please contact your advisor for assistance.",
    failedToCheckStatus: "Failed to check status",
    failedToCheckSignatureStatus: "Failed to check signature status",
  },
  nb_NO: {
    advisorCannotAccess:
      "Rådgivere kan ikke få tilgang til offentlige kundelenker. Vennligst logg ut fra rådgiverpanelet først.",
    invalidOrExpiredLink: "Ugyldig eller utlopt signaturlenke",
    failedToLoadSignaturePage: "Kunne ikke laste signatursiden",
    unableToLoadSignaturePage: "Kunne ikke laste signatursiden",
    contactAdvisorForAssistance: "Vennligst kontakt din radgiver for hjelp.",
    documentSigning: "Dokumentsignering",
    welcome: "Velkommen,",
    requestedToSign: "Du har blitt bedt om a signere dokumenter med din elektroniske ID",
    secureDigitalSigning: "Sikker digital signering",
    secureDigitalSigningDesc:
      "Du vil bli omdirigert til en sikker signeringsportal hvor du kan bruke din elektroniske ID (MitID, BankID eller lignende) for a signere dokumentene.",
    whatHappensNext: "Hva skjer videre?",
    step1: "Klikk pa knappen nedenfor for a starte signeringsprosessen",
    step2: "Du vil bli omdirigert til den sikre Criipto-signeringsportalen",
    step3: "Velg din foretrukne elektroniske ID-metode",
    step4: "Autentiser med din valgte eID",
    step5: "Gjennomga og signer dokumentene",
    step6: "Du vil motta en bekreftelse nar signeringen er fullfort",
    currentStatus: "Gjeldende status:",
    signed: "Signert",
    inProgress: "Pagar",
    pending: "Venter",
    expired: "Utlopt",
    cancelled: "Avbrutt",
    failed: "Mislyktes",
    signedLabel: "Signert:",
    signerLabel: "Signert av:",
    signatureSuccessfullyCompleted: "Din signatur er fullfort!",
    alreadySigned: "Allerede signert",
    startSigningProcess: "Start signeringsprosessen",
    checkStatus: "Sjekk status",
    secureAndCompliant: "Sikker og i samsvar",
    secureAndCompliantDesc:
      "Denne signeringsprosessen bruker Criipto Signatures, en palitelig leverandor av digitale signaturer. Dokumentene dine vil bli signert i henhold til PAdES-LTA-standarder, som sikrer juridisk gyldighet.",
    afterSigning: "Etter signering",
    afterSigningDesc:
      'Etter at du har fullfort signeringsprosessen pa Criipto-portalen, ga tilbake til denne siden og klikk "Sjekk status" for a bekrefte at signaturen din ble mottatt.',
    needHelp: "Trenger du hjelp?",
    needHelpDesc:
      "Hvis du opplever problemer med signeringsprosessen, vennligst kontakt din radgiver for hjelp.",
    failedToCheckStatus: "Kunne ikke sjekke status",
    failedToCheckSignatureStatus: "Kunne ikke sjekke signaturstatus",
  },
} as const;
